import React, { FC } from 'react'
import { observer } from 'mobx-react'
import i18n from 'i18next'
import { throttle } from '@dt/fe-utils/dist/lodash'
import './index.scss'

interface IProps {
  text?: string;
  size?: 'small' | 'large' | 'middle';
  style?: 'radius' | 'square' | 'border';
  loading?: boolean;
  disabled?: boolean;
  className?: string;
  onClick?: (e?: any) => void;
  insideStyle?: React.CSSProperties;
}
interface IState {
}

const MktButton: FC<IProps> = (props) => {
  const { text, onClick = () => null, size = 'large', style = 'radius', disabled, loading, insideStyle } = props
  const handleClick = throttle(onClick, 1000)
  let { className = '' } = props
  className += ' mkt-btn'
  className += size ? ` ${size}` : ''
  className += style ? ` ${style}` : ''
  className += disabled || loading ? ' disabled' : ''
  return (
    <div data-cypid='mmgClickBtn' className={className} onClick={disabled || loading ? null : handleClick} style={insideStyle}>
      {props.children}
      {text}
    </div>
  )
}

export default observer(MktButton)
